export default function getIntoNested({
  nestedProduct,
  addedProducts,
  inputData,
  fetchProductsBySection,
  treeStructureSettings,
  setTreeStructureSettings,
  setOpenModal,
  accessories,
  cornerPostAccessories,
  isRootNode,
}) {
  if (addedProducts.includes(`${nestedProduct['@id']}${nestedProduct.association}`)) {
    fetchProductsBySection({
      section: 'accessory',
      accessoryGroup: nestedProduct.productGroup.number,
      color: inputData.color,
      isRootNode,
    });
    setTreeStructureSettings(treeStructureSettings.level, {
      ...treeStructureSettings.parentId,
      [treeStructureSettings.level]: `${nestedProduct['@id']}${nestedProduct.association}`,
    }, {
      ...treeStructureSettings.parentName,
      [treeStructureSettings.level]: `${nestedProduct.description}`,
    });

    if (cornerPostAccessories || accessories) {
      setOpenModal('nestedAccessories', true);
    }
  }
}
